import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ambiente from '../../config/ambienteConfig';
import { exibirMensagem } from '../../redux/actions/mensagemAction';

class ProventosUltraQuickAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            proventos: [],
            resp: { problemas: [], proventosSalvos: [] },
            text: '',
        };
    }

    handleParse = () => {
        const proventos = [];
        const erros = [];
        this.state.text.split('\n').forEach(line => {
            const cell = line.split('\t');
            if (cell.length === 9) {
                proventos.push({ ativo: cell[2].trim(), data: cell[3].trim(), tipo: cell[4].trim(), valor: cell[8].trim().replace(',', '.') });
            } else {
                erros.push(`Linha '${line}' inválida`);
            }
        });
        this.setState({ proventos, resp: { erros, proventos } });
    }

    handleSave = async () => {
        try {
            const result = await axios.post(`${ambiente.dev.server}/proventosLote`, this.state.proventos);
            this.setState({ resp: result.data });
            this.props.exibirMensagem('yay', `Proventos inseridos com sucesso!`);
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="form-group col-12">
                        <textarea className="form-control" rows="20" onChange={evt => this.setState({ text: evt.target.value })} value={this.state.text} />
                    </div>
                </div>
                <button type="button" className="btn btn-primary btn-block" onClick={this.handleParse}>
                    Check
                </button>
                <table className="table table-hover table-bordered">
                    <thead className="thead-inverse">
                        <tr>
                            <th>Ativo</th>
                            <th>Data</th>
                            <th>Tipo</th>
                            <th>Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.proventos.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td>{item.ativo}</td>
                                    <td>{item.data}</td>
                                    <td>{item.tipo}</td>
                                    <td>{parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                </tr>);
                        })}
                    </tbody>
                </table>
                <button type="button" className="btn btn-primary btn-block" onClick={this.handleSave}>
                    Save
                </button>
                <div className="row">
                    <div className="form-group col-12">
                        <textarea className="form-control" rows="20" onChange={evt => this.setState({ resp: evt.target.value })} value={JSON.stringify(this.state.resp, null, 2)} />
                    </div>
                </div>
            </div>
        );
    }
}

ProventosUltraQuickAdd.propTypes = {
    exibirMensagem: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProventosUltraQuickAdd);



// WEBPACK FOOTER //
// ./src/components/proventos/ProventosUltraQuickAdd.js